<template>
  <yxtf-scrollbar
    v-if="source"
    :wrap-class="wrapClass"
    :fit-height="true"
  >
    <div class="g2-popover g2-label-popover">
      <div class="g2-popover-title yxt-weight-5">
        <div class="max-width-312 ellipsis">
          {{ labelData.name }}
        </div>
      </div>
      <ul class="g2-popover-list">
        <li
          v-for="(item, index) in subSkills"
          :key="index"
          class="g2-popover-list_item"
          :class="{'pb4' : index + 1 !== subSkills.length}"
        >
          <div class="g2-popover-name maxWidth250 ellipsis">
            {{ item.skill && item.skill.name || item.name }}{{ levelFormatter({...item, fieldsType: 'combStandardLevel'}) && ':' }}
          </div>
          <div class="g2-tooltip-value ml16">
            {{ levelFormatter({...item, fieldsType: 'combStandardLevel'}) }}
          </div>
        </li>
      </ul>
    </div>
  </yxtf-scrollbar>
  <div
    v-else
    class="radar-label-tooltip"
  >
    <div class="radar-label-tooltip__header ellipsis">
      {{ labelData.name }}({{ subSkills.length }})
    </div>
    <div class="radar-label-tooltip__skills clearfix flex">
      <div
        v-for="(item, index) in subSkills"
        :key="index"
        class="radar-label-tooltip__skill"
        :class="{'mr34': index!==subSkills.length-1}"
      >
        <div class="ellipsis mb12 color-gray-8 lh22 font-size-14">
          {{ item.name }}
        </div>
        <div>
          <div
            v-for="(range, index1) in legendFields"
            :key="index1"
            class="radar-label-tooltip__level flex align-items-center color-gray-9 lh22 font-size-14"
            :class="{'mt4': index1 !==0}"
          >
            <i
              class="flex-shrink-0"
              :style="{'background-color': legendMap[range].color}"
            />{{ legendMap[range].label }}<span class="ellipsis maxWidth200">{{ valueMap ? valueMap({...item, fieldsType: range}, true) : (item[range] || '0') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // tooltip value 映射方法
    valueMap: {
      type: Function,
      default: undefined
    },
    id: {
      type: String
    },
    subSkills: {
      type: Array,
      default: () => {
        return [];
      }
    },
    legendFields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    legendMap: {
      type: Object,
      default: () => {
        return {};
      }
    },
    labelData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    source: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isDisabled: false,
      wrapClass: ['custom-wrap']
    };
  },
  watch: {
    pager: {
      handler: function(val) {
        if (val.offset === 0) {
          this.currentPage = 1;
        }
      },
      deep: true
    }
  },
  methods: {
    levelFormatter(item) {
      const v = item[item.fieldsType];
      if (this.valueMap) {
        return this.valueMap(item, true);
      }
      if (typeof v === 'number' && v % 1 === 0) {
        return v;
      } else {
        return v.toFixed(2);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.g2-popover {
  min-width: 192px;
  max-width: 360px;
  // height: 400px;

  .max-width-126 {
    width: 126px;
  }

  .max-width-312 {
    width: 100%;
    max-width: 312px;
  }

  .maxWidth250 {
    max-width: 250px;
  }

  .g2-popover-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px !important;
    color: #595959;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }

  .g2-popover-list_item {
    display: flex;
    font-size: 14px;
    line-height: 22px;

    .g2-popover-name {
      display: inline-block;
    }
  }
}

.radar-label-tooltip {
  // width: 480px;
  max-height: 250px;

  ::v-deep .yxt-scrollbar__view {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  &__level {
    white-space: nowrap;

    i {
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 10px;
      border-radius: 50%;
    }

    span {
      margin-left: 12px;
    }
  }
}

.radar-label-tooltip__header {
  // height: 48px;
  padding: 12px 16px 10px 16px;
  color: #262626;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  border-bottom: 1px solid #e9e9e9;
}

.radar-label-tooltip__skills {
  // height: 154px;
  padding: 14px 16px;
  overflow: auto;
}

.radar-label-tooltip__skill {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // width: 33%;
  // padding: 10px;
  max-width: 250px;
  color: #8c8c8c;
}

.maxWidth200 {
  display: inline-block;
  max-width: 200px;
}
</style>
